// removed by extract-text-webpack-plugin
module.exports = {"container":"magazines_1RXB0","btn":"magazines_2FQmU","icon":"magazines_TPNsk","addon":"magazines_1D2T8","active":"magazines_2-pd0","dropdown":"magazines_CAElD","animation__dropdown":"magazines_1JO7R"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/components/MagazineSizeDropdown/styles.scss
// module id = 1050
// module chunks = 1